import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './auth';
import PageLoading from './PageLoading';

export default function ProtectedRoute({ role, children }) {
  const { isAuthenticated, isInitializing, user } = useAuth();

  if (isInitializing) return <PageLoading />;
  if (!isAuthenticated || user?.owner !== role) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
